<script setup lang="ts">
import { storeOrdersApiClient } from "@api-client/store_orders";
import type { ResType } from "@api-client/typeUtils";
import { computed } from "vue";
import OrderCard from "./OrderCard.vue";

const ApiPath = storeOrdersApiClient[":storeId"].get_by_order_ids.$post;
type OrdersData = ResType<typeof ApiPath>["data"];

const props = defineProps<{
    cachedStoreOrders: Record<string, OrdersData[number]>;
}>();

const orders = computed(() => {
    return Object.values(props.cachedStoreOrders).sort((a, b) => b.order_placed_at_ts - a.order_placed_at_ts);
});
</script>
<template>
    <div class="space-y-4">
        <div v-for="order in orders"
             :key="order.storeOrderId"
             class="block">
            <OrderCard :order="order"
                       :cachedStoreOrders="cachedStoreOrders" />
        </div>
    </div>
</template>